// extracted by mini-css-extract-plugin
module.exports = {"trade-finance":"TradeFinance_trade-finance__Tu_Sa"};